import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { parseImageURL } from '@prehook/shared'
import './layout.css'
import { device } from '../utils'

const Background = styled.main`
  display: flex;
  position: relative;
  height: ${({ settings }) =>
    settings?.popupHeight ? settings.popupHeight + 'vh' : '100vh'};
  width: ${({ settings }) =>
    settings?.popupWidth ? settings.popupWidth + 'vw' : '100vw'};
  overflow-y: hidden;
  background-color: ${({ backgroundColor }) => backgroundColor || '#fff'};
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-size: cover;
  font-family: ${({ font }) => font || 'Open Sans'};
  justify-content: center;
  align-items: center;
  @media ${device.mobile} {
    height: ${({ settings }) =>
      !settings?.popupHeight || parseInt(settings?.popupHeight) < 80
        ? '100vh'
        : settings.popupHeight + 'vh'};
    width: ${({ settings }) =>
      !settings?.popupWidth || parseInt(settings?.popupWidth) < 80
        ? '100vw'
        : settings.popupWidth + 'vw'};
  }
`

const Layout = ({ children, theme, settings }) => {
  // TODO: add background position ie, cover, repeat etc.
  const { backgroundColor, backgroundImage, font } = theme
  const imageURL = parseImageURL({
    image: backgroundImage,
    size: 'lrg',
    imageDomain: process.env.GATSBY_IMAGE_DOMAIN,
    bucketName: process.env.GATSBY_S3_BUCKET_NAME,
  })

  return (
    <Background
      backgroundColor={backgroundColor}
      backgroundImage={imageURL}
      settings={settings}
      font={font}>
      {children}
    </Background>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
